define('controllers/memberservices/commodityList',['app', 'mainCons'], function (app, mainCons) {
    app.controller('CommodityList', ['$scope', '$q', '$rootScope', '$state', '$location', 'UserInfo', 'auiDialog', 'paidMemberService', 'commonUtils',
        function ($scope, $q, $rootScope, $state, $location, UserInfo, auiDialog, paidMemberService, commonUtils) {
            var Model = $scope.Model = {
                commodityList :[],
                selectCommodity :'',
                commodityMutexList : {},
                commodity4User : {},
                commodityPrice : {},
                commodityLangCN: {},
                commodityAssetList : [],
                commodityVectorList:[],
                commodityCycle : mainCons.commodityConstant.commodityCycle,
                currencyType : mainCons.commodityConstant.currencyType,
                effectiveType : mainCons.commodityConstant.effectiveType,
                renewType : mainCons.commodityConstant.renewType,
                showUnit : mainCons.commodityConstant.showUnit,
                commodityCycle1 : mainCons.commodityConstant.commodityCycle1,
                repeatOrder : mainCons.commodityConstant.repeatOrder,
                limitPeriodType : mainCons.commodityConstant.limitPeriodType,
                showSignAgreeSign : false
            };
            $rootScope.currentMycommodity ={};
            $scope.goDetail = goDetail;
            $scope.orderPlan=orderPlan; //订购套餐
            $scope.clickTab = clickTab;
            $scope.showAgreement = showAgreement;
            $scope.goBack = goBack;

            init();

            function init() {
                //查询自己购买的套餐
                paidMemberService.getUserSubscriptionList().then(function(u){
                    if(u && u.userSubscriptionList && u.userSubscriptionList.length > 0 ){
                        for(var j in u.userSubscriptionList){
                            var userSubscription = u.userSubscriptionList[j]
                            //生效的、退订中的，则需要存储互斥的套餐列表
                            if(userSubscription.status == 1 || userSubscription.status == 5){
                                Model.commodityMutexList[userSubscription.commodityID] = "true";
                            }
                        }
                    }
                    //查询所有的套餐
                    paidMemberService.getCommodityList().then(function(c){
                        if(c && c.commodityList && c.commodityList.length > 0 ){
                            for(var i in c.commodityList){
                                Model.commodityList.push(c.commodityList[i]);
                            }
                        }
                    });
                });

                //判断是否签署过协议
                paidMemberService.getIsSignAgreement(mainCons.commodityConstant.argeementNo).then(function(signedText){
                    if(signedText)
                    {
                        // 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                        if (signedText.signStatus == 1 || (signedText.signStatus == 2 && signedText.isForcedSign != 'true')) {
                            Model.showSignAgreeSign = true;
                        }
                    }
                });
            }

            function goDetail(selectCommodity){
                Model.selectCommodity = selectCommodity;
                paidMemberService.queryCommodityDetail(selectCommodity.commodityID).then(function(data){
                    document.getElementById("tab-03").scrollIntoView({behavior: "smooth"});
                    if(data && data.commodity4User){
                        var commodity4User = Model.commodity4User = data.commodity4User;
                        //取中文的价格信息
                        if(commodity4User.commodityPriceList){
                            for(var i in commodity4User.commodityPriceList){
                                if(commodity4User.commodityPriceList[i].regionType == 'CN' ){
                                    Model.commodityPrice = commodity4User.commodityPriceList[i];
                                }
                            }
                        }

                        if(commodity4User.commodityLangList){
                            for(var j in commodity4User.commodityLangList){
                                if( commodity4User.commodityLangList[j].lang == 'zh_CN'){
                                    Model.commodityLangCN = commodity4User.commodityLangList[j];
                                }
                            }
                        }

                        if(commodity4User.commodityAssetList){
                            Model.commodityAssetList = [];
                            Model.commodityVectorList = [];
                            for(var k in commodity4User.commodityAssetList){
                                var commodityAsset = commodity4User.commodityAssetList[k];
                                for(var l in commodityAsset.assetLangList){
                                    if('zh_CN' == commodityAsset.assetLangList[l].lang){
                                        commodityAsset.assetLang = commodityAsset.assetLangList[l];
                                    }
                                }
                                if(commodityAsset.serviceDomain == 2){
                                    //有限制或者可计量，需要显示数量
                                    if(commodityAsset.isLimited == 1 || commodityAsset.isPlural == 1){
                                        if(commodityAsset.isLimited == 1){
                                            //1.byte 2.MB 3.GB 4.TB 5.个 6.次
                                            if(commodityAsset.limitShowUnit == 2){
                                                commodityAsset.limitQuantity = commodityAsset.limitQuantity / 1024 /1024;
                                            }else if(commodityAsset.limitShowUnit == 3){
                                                commodityAsset.limitQuantity = commodityAsset.limitQuantity / 1024 / 1024 /1024;
                                            }else if(commodityAsset.limitShowUnit == 4){
                                                commodityAsset.limitQuantity = commodityAsset.limitQuantity / 1024 / 1024 / 1204 /1024;
                                            }
                                        }else{
                                            //1.byte 2.MB 3.GB 4.TB 5.个 6.次
                                            if(commodityAsset.showUnit == 2){
                                                commodityAsset.quantity = commodityAsset.quantity / 1024 /1024;
                                            }else if(commodityAsset.showUnit == 3){
                                                commodityAsset.quantity = commodityAsset.quantity / 1024 / 1024 /1024;
                                            }else if(commodityAsset.showUnit == 4){
                                                commodityAsset.quantity = commodityAsset.quantity / 1024 / 1024 / 1204 /1024;
                                            }
                                        }
                                    }
                                    Model.commodityVectorList.push(commodityAsset);
                                }else{
                                    Model.commodityAssetList.push(commodityAsset);
                                }
                            }
                        }
                    }
                });
            }

            function orderPlan(c){
                //校验该套餐有没有和已购买套餐冲突
                if(c.commodityMutexList){
                    for(var l in c.commodityMutexList){
                        if(Model.commodityMutexList[c.commodityMutexList[l].mutexCommodityID]){
                            auiDialog.fail('无效操作','尊敬的开发者您好，该套餐与您的已有套餐冲突，不可订购。如有疑问请' + window.contactUS);
                            return;
                        }
                    }
                }
                paidMemberService.orderPlan(c,1);
            }

            function clickTab(){
                $state.go('memberservices.myCommodityList');
            }

            function showAgreement(){
                commonUtils.showAgreement([mainCons.commodityConstant.argeementNo]);
            }

            function goBack(){
                document.getElementById("tab-01").scrollIntoView();
            }



        }
    ]);
});
